import React, { forwardRef } from 'react'
import {
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from 'react-router-dom'

export function withRouter<ComponentProps>(
  Component: React.FunctionComponent<ComponentProps>
) {
  const ComponentWithRouterProp = forwardRef<ComponentProps, any>(
    (props, ref) => {
      const location = useLocation()
      const navigate = useNavigate()
      const navigationType = useNavigationType()
      const params = useParams()

      return (
        <Component
          {...props}
          ref={ref}
          router={{ location, navigate, navigationType, params }}
        />
      )
    }
  )

  ComponentWithRouterProp.displayName = `withRouter(${
    Component.displayName || Component.name || 'Component'
  })`
  return ComponentWithRouterProp
}
